export default __webpack_public_path__ + "236978f74c0ee34cfe2a3030759664cf.png";